export default __webpack_public_path__ + "static/media/AuthorDesk.ef3d8bdc92d6e3fe42270ea21e2de004.webp";